export default "__VITE_ASSET__CZ3_OiCu__"